<template>
  <div class="user-know">
    <div class="update">
      <p>更新日期：更新日期：2022年6月2日</p>
      <p>生效日期：更新日期：2022年6月2日</p>
    </div>
    <div class="title">版权声明</div>
    <div>欢迎光临并使用知心慧学，用户在使用知心慧学前请认真阅读本声明，用户开始使用知心慧学即表明已了解、尊重并遵守本声明的所有内容。如用户对本声明有任何异议，请不要使用知心慧学。在以下声明中，知心慧学的用户统称为“您”。
    </div>
    <div>1、知心慧学由江西风向标智能科技有限公司（以下简称“风向标”）出品，其载体包括手机APP、H5、网站、公众号、小程序等，上述载体的所有权、经营权、管理权均属于风向标。本版权声明适用于上述所有载体。</div>
    <div>
      2、您在知心慧学上传的文章、试卷、课题集、作业集、课件、教案、学案等文字、图形资料和音频、视频材料（以下统称“作品”），如属于您原创，即表示上述作品的著作权归风向标所有，或由您与风向标协议约定共同所有。您保证对于您上传的原创作品拥有完整的、无瑕疵的著作权，若因第三方向风向标追究上述作品著作权的法律责任，给风向标造成的一切损失由您全部承担。
    </div>
    <div>
      3、您转载他人的材料上传至知心慧学，必须取得原著作权人的同意或非排他性许可，您通过其他渠道转载到知心慧学的材料，须得到来源渠道的许可，如可以不经来源渠道许可转载的，您也须注明来源渠道的名称或地址，否则一切后果由您全部承担。
    </div>
    <div>4、您承诺：您在知心慧学所上传的所有作品内容符合法律、法规和规范性文件的相关规定，不侵犯任何第三方的合法权益。如您违反前述保证，风向标有权删除相关内容，并可以暂停或终止向您提供服务。</div>
    <div>
      5、任何转载知心慧学已经刊登的作品的，均须得到作品原著作权人和风向标的同意，否则因此引发的法律责任由转载方全部承担；作品原著作权人和风向标未声明不得转载的，转载方也应在转载时注明作品出处，且不得对所转载内容进行任何形式的篡改、增减、节选、歪曲等，否则风向标将依法追究其法律责任。
    </div>
    <div>6、转载或引用知心慧学原创或首发内容时，须注明作者姓名，并标注“来源：知心慧学 <a href="http://www.zhixinhuixue.com">www.zhixinhuixue.com</a>”，转载须保持作品完整，违者风向标将依法追究其责
    </div>
    <div>7、对于知心慧学发布的非原创或非首发内容，均转载自其它媒体、杂志、刊物，转载目的在于传递更多信息，并不代表知心慧学赞同其观点和对其真实性负责。</div>
    <div>8、知心慧学不拥有转载作品的版权，无权许可他人转载。如需转载，请联系著作权人，以获取授权。引用、转载、复制、摘编或以其他任何方式使用转载作品的，必须保留本网站注明的“来源”，不得擅自篡改为“来源：知心慧学
      www.zhixinhuixue.com”，违者本网站将依法追究其责任。
    </div>
    <div>9、擅自使用知心慧学名义转载不规范来源的信息、版权不明的资讯、稿件等作品，或盗用知心慧学名义发布信息，风向标将依法追究其法律责任。</div>
    <div>10、异议协调：对于知心慧学发布内容的版权或相关事项有异议的，请及时联系风向标协商处理。邮箱：<a href="mailto:info@fxbjy.com" class="blue">info@fxbjy.com</a></div>
    <div>
      11、因业务调整，本声明可能随时被修改。您应经常访问本页面以便了解当前的条款，因为这些条款与您密切相关。这些条款的某些条文也可能被知心慧学中某些页面上或某些具体服务明确指定的法律通告或条款所取代，您应该了解这些内容，一旦接受本条款，即意味着您已经同时详细阅读并接受了这些被引用或取代的条款。
    </div>
    <div>12、风向标拥有对本声明的最终解释权。</div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
  }
</script>

<style lang="less" scoped>
  .user-know {
    .title {
      text-align: center;
      color: #333;
      font-weight: bold;
    }
    padding: 0.2rem 0.4rem;
    font-size: 0.36rem;
    line-height: 0.6rem;
    text-align: justify;

    .blue {
      text-decoration: underline;
      color: blue;
    }
  }
</style>



// WEBPACK FOOTER //
// Version.vue?eaf4a1a4